import { fromJS, OrderedSet, Map } from 'immutable';
import { handleActions, combineActions } from 'redux-actions';

import {
  LOGOUT,
} from 'features/authentication';

import {
  ADD_OR_UPDATE_CASES,
  ADD_OR_UPDATE_CURRENT_CASE,
  ADD_OR_UPDATE_SERVICE_PROVIDERS,
  CLEAR_SERVICE_PROVIDERS,
  RESET_FAVORITES,
} from '../constants';

export const initialState = fromJS({
  responseIds: OrderedSet(),
  byId: {},
});

function updateFromCasesHandler(state, action) {
  const {
    entities: {
      serviceProvider: newServiceProviders = {},
    } = {},
  } = action.payload;

  const currentById = state.get('byId');
  const newById = currentById.merge(currentById, { ...newServiceProviders });
  return state
    .set('byId', newById);
}

function resetState(state) {
  return state
    .set('responseIds', OrderedSet())
    .set('byId', Map());
}

function addOrUpdateServiceProvidersHandler(state, action) {
  const {
    entities: {
      serviceProvider: newServiceProviders = {},
    } = {},
    result = [],
  } = action.payload;
  const currentAllIds = state.get('responseIds');
  const newAllIds = currentAllIds.concat(result);

  const currentById = state.get('byId');
  const newById = currentById.merge(currentById, { ...newServiceProviders });

  return state
    .set('responseIds', newAllIds)
    .set('byId', newById);
}

export default handleActions({
  [ADD_OR_UPDATE_SERVICE_PROVIDERS]: addOrUpdateServiceProvidersHandler,
  [combineActions(ADD_OR_UPDATE_CASES, ADD_OR_UPDATE_CURRENT_CASE)]: updateFromCasesHandler,
  [combineActions(CLEAR_SERVICE_PROVIDERS, RESET_FAVORITES, LOGOUT)]: resetState,
}, initialState);



// WEBPACK FOOTER //
// ./redux/serviceProviders/reducer.js